<template>
    <div>
        <div class="main1">
            <p class="welcome">Welcome to NdotCAD!</p>
            <h1>{{this.EventBus.getText("home_sec1_title")}}<br>{{this.EventBus.getText("home_sec1_title2")}}</h1>
            
            <p>{{this.EventBus.getText("home_sec1_text1")}}</p>
            <p>{{this.EventBus.getText("home_sec1_text2")}}</p>
            
            
            <div class="mt-5">
                <p>{{this.EventBus.getText("home_sec1_text3")}}</p>
                <a href="https://www.youtube.com/channel/UCpQPDIZtGC6re2Ws0muBNkg">
                <img src="/static/sns/youtube.png" alt=""></a>
                <a href="https://www.facebook.com/ndotcad">
                <img src="/static/sns/facebook.png" alt=""></a>
                <a href="https://www.instagram.com/ndotcad/">
                <img src="/static/sns/instagram.png" alt=""></a>
            </div>
             
            <!-- <a href="http://www.freepik.com">Designed by pikisuperstar / Freepik<img src="" alt=""></a> -->
        </div>
        <div class="main_img">
                <img src="/static/main_img_5.png" alt="">
            </div>
        <div class="main2 text-center">
            <div>
                <h1>{{this.EventBus.getText("home_sec2_title")}}</h1>
                <p>{{this.EventBus.getText("home_sec2_text")}}</p>

            </div>

            <div class="container">
                <div class="item">
                    <img src="/static/tutorial/steps/tutorial_steps_1.png" alt="">
                    <h3>{{this.EventBus.getText("home_sec2_div1_title")}}</h3> 
                    <p>{{this.EventBus.getText("home_sec2_div1_text")}}</p>
                    <nav><ul><li class="pointer" onclick="location.href='/function'">GO<span></span><span></span><span></span><span></span></li></ul></nav>
                </div>
                <div class="item">
                    <img src="/static/tutorial/steps/tutorial_steps_2.png" alt="">
                    <h3>{{this.EventBus.getText("home_sec2_div2_title")}}</h3>
                    <p>{{this.EventBus.getText("home_sec2_div2_text")}}</p>
                    <nav><ul><li class="pointer" onclick="location.href='/menu'">GO<span></span><span></span><span></span><span></span></li></ul></nav>
                </div>
                <!-- <div class="item">
                    <img src="/static/tutorial/steps/tutorial_steps_3.png" alt="">
                    <h3>{{this.EventBus.getText("home_sec2_div3_title")}}</h3>
                    <p>{{this.EventBus.getText("home_sec2_div3_text")}}</p>
                    <nav><ul><li class="pointer" onclick="location.href='/tutorial_main'">GO<span></span><span></span><span></span><span></span></li></ul></nav>
                </div> -->
            </div>
        </div>
        
        <div class="video">
            <h2>{{this.EventBus.getText("home_sec3_title")}} </h2>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/cfmDlkjev7g" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <p>{{this.EventBus.getText("home_sec3_text")}}<br>{{this.EventBus.getText("home_sec3_text2")}}<br>{{this.EventBus.getText("home_sec3_text3")}}</p>
        </div>


        <Footer/>
        <js/>
        <!-- <Footer/> -->
    </div>
</template>
<script>
import Home from "../assets/language/home.json";
export default {
  created() {
    this.EventBus.loadLanguage(Home);
  }
};
</script>

<style scoped>
p {
  font-size: 1.1rem;
  padding: 0px;
  margin: 0px;
  color: #707070;
  line-height: 140%;
  letter-spacing: 0.1vw;
}
h1 {
  font-size: 2.5rem;
  color: #707070;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: 0.1vw;
  margin-bottom: 20px;
}
h2 {
  font-weight: 700;
  color: #707070;
  letter-spacing: 0.1vw;
  margin-bottom: 40px;
}
h3 {
  font-size: 1.2rem;
  color: #141414;
  margin-bottom: 3vh;
}
.main_img {
  margin-top: 100px;
  position: absolute;
  top: 20px;
  right: 0;
  width: 50vw;
  overflow: hidden;
}

.main_img img {
  width: 100%;
}
.welcome {
  color: #85e5e9;
  margin-bottom: 2vh;
  font-weight: 700;
  letter-spacing: 0.1vw;
}
.main1 {
  padding: 8vw;
  margin: 8vw 3vw;
}
.main1 img {
  width: 3.7vw;
  padding-right: 2vw;
  padding-top: 2vh;
}
.main2 {
  margin: 5vh auto;
  /* background-color: lightgrey; */
}

.container {
  display: flex;
  justify-content: space-around;
}
.item {
  border-radius: 70px;
  box-shadow: #707070;
  /* width: 20%; */
  margin: 50px 70px;
  padding: 3vw;
  height: 550px;
  box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.05);
  text-align: center;
  /* display: inline-block; */
}

.item img {
  padding: 0px;
  /* width: 70%; */
  height: 30%;
  margin: 10px 0px;
}
.item p {
  font-size: 1rem;
  letter-spacing: 0.03vw;
  color: #141414;
}

.video {
  background: #f8f6f6;
  padding: 100px;
  text-align: center;
}

.video p {
  letter-spacing: 0.05vw;
  font-size: 1.1rem;
  color: #141414;
  margin: 60px 0px;
}

@media screen and (max-width: 600px) {
  .steps {
    width: 100%;
    margin: 20px 50px;
  }
}

@media screen and (max-width: 768px) {
  .steps {
    width: 100%;
    margin: 20px 50px;
  }
}

.pointer {
  cursor: pointer;
}

nav ul {
  list-style-type: none;
  margin: 50px 10px 100px 30px;
  padding: 0;
  text-align: center;
}
nav ul li {
  --c: #1ecad3;
  color: var(--c);
  font-size: 16px;
  border: 2px solid var(--c);
  border-radius: 1.5em;
  width: 8em;
  height: 2.5em;
  letter-spacing: 0.1em;
  text-align: center;
  font-weight: 500;
  line-height: 2.5em;
  position: relative;
  overflow: hidden;
  /* z-index: 1; */
  transition: 0.5s;
  margin: 4em;
}

nav ul li span {
  position: absolute;
  width: 25%;
  height: 100%;
  background-color: var(--c);
  transform: translateY(150%);
  border-radius: 50%;
  left: calc((var(--n) - 1) * 25%);
  transition: 0.5s;
  transition-delay: calc((var(--n) - 1) * 0.1s);
  z-index: -1;
}

nav ul li:hover {
  color: white;
}

nav ul li:hover span {
  transform: translateY(0) scale(2);
}

nav ul li span:nth-child(1) {
  --n: 1;
}

nav ul li span:nth-child(2) {
  --n: 2;
}

nav ul li span:nth-child(3) {
  --n: 3;
}

nav ul li span:nth-child(4) {
  --n: 4;
}
</style>



// WEBPACK FOOTER //
// src/pages/tutorial_main.vue